import React, { useEffect, useState } from 'react'
import Topbar from './Topbar'
import { Link, useNavigate } from 'react-router-dom'
import $ from 'jquery'
import Sidebar_component from './Sidebar_component'

export default function Report_history() {
    const [reportsarray, setReportsarray] = useState([]);
    const [sidebarOpen, setSidebarOpen] = useState(false);
    useEffect(() => {
        const userid = localStorage.getItem('member_id');
        var obj = {
            userid: userid
        }
        $.ajax({
            type: 'POST',
            url: 'getReportHistory.php',
            data: obj,
            cache: false,
            success: function (result) {

                try {
                    const parsedResult = result;
                    if (Array.isArray(parsedResult) && parsedResult.length > 0) {
                        setReportsarray(parsedResult);

                    } else {
                        showAlert('You have No report history.');
                        setReportsarray([]); // just in case
                    }
                } catch (e) {
                    showAlert('Failed to load your record.');
                    setReportsarray([]); // fallback to prevent map crash
                }
            },
        });

    }, [])
    function showAlert(msg) {
        $('#alertpop').css('display', 'block');
        $('#alert_text').text(msg);
    }

    function closeAlert() {
        $('#alertpop').css('display', 'none');
        $('#alert_text').text('');
    }
    const toggleSidebar = () => {
        setSidebarOpen(!sidebarOpen);
    };
    return (
        <div>
            <Topbar toggleSidebar={toggleSidebar} />
            <Sidebar_component sidebarOpen={sidebarOpen} />
            <div className='vl_dsh_bodypart'>
                <div className='vl_alltab'>
                    <h2 className='bigfonttabs'>Report History</h2>
                    <Link className='pull_right add_new_pro' to="/member_daily_report">Daily Report</Link>

                </div>
                <section className='mainsection'>
                    <div className='vl_dsh_container'>
                        <div className='vl_dsh_one_full'>
                            <div className='fullwidth tasklistarea mt-20 pull_left'>
                                <table className="activity-table">
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>Report Date</th>
                                            <th>Report summery</th>
                                            <th>Status</th>
                                            <th>Acknowledge</th>
                                            <th>Review</th>
                                            <th>Issues</th>
                                            <th>Seen At</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {reportsarray.map((report, index) => (
                                            <tr key={report.report_id}>
                                                <td>{index + 1}</td>

                                                <td>{report.report_date}</td>

                                                <td className="ellipsis">
                                                    {report.summary.substring(0, 60)}...
                                                </td>

                                                <td>
                                                    <span className={`status ${report.status}`}>
                                                        {report.status}
                                                    </span>
                                                </td>

                                                <td>
                                                    {report.acknowledged_at
                                                        ? new Date(report.acknowledged_at).toLocaleString()
                                                        : "—"}
                                                </td>

                                                <td>
                                                    {report.review_note
                                                        ? report.review_note.substring(0, 40) + "..."
                                                        : "—"}
                                                </td>

                                                <td>
                                                    {report.issues ? report.issues : "—"}
                                                </td>

                                                <td>
                                                    {report.seen_at
                                                        ? new Date(report.seen_at).toLocaleString()
                                                        : "—"}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>

                                </table>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            <div className='vl_dsh_popup' id="alertpop">
                <div className='alertbox'>
                    <div className='alertheader'><h3><i className='ri-alert-line'></i>Alert</h3></div>
                    <div className='contentarea'>
                        <p id="alert_text"></p>
                    </div>
                    <div className='alert_btns'>
                        <button onClick={closeAlert}>Okay</button>
                    </div>
                </div>
            </div>
        </div>
    )
}
